import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCore = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.53112 3.48199L7.75378 7.11871L3.73425 7.69292C3.02331 7.8023 2.74987 8.6773 3.2694 9.19683L6.1405 12.0132L5.4569 15.9781C5.34753 16.689 6.11315 17.2359 6.74206 16.9078L10.3241 15.021L13.8788 16.9078C14.5077 17.2359 15.2733 16.689 15.1639 15.9781L14.4803 12.0132L17.3514 9.19683C17.871 8.6773 17.5975 7.8023 16.8866 7.69292L12.8944 7.11871L11.0897 3.48199C10.7889 2.85308 9.85925 2.82574 9.53112 3.48199Z",
		fill: "#FFCD38"
	})
});
export default SvgCore;
